import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Box, Flex, Grid, IconButton } from '@chakra-ui/react';
import { Dialog, Svg } from '../../base';
import { ComponentPlacement } from './components';
const isChildrenRenderProps = (val) => {
    return typeof val === 'function';
};
export const DialogableContainer = ({ title, children, isReadOnly, dialogMinWidth, floatMinWidth }) => {
    const [isDialog, setIsDialog] = useState(false);
    const handleToggleDialog = useCallback(() => {
        setIsDialog((prev) => !prev);
    }, []);
    const content = isChildrenRenderProps(children)
        ? children(isDialog, handleToggleDialog)
        : children;
    return (_jsxs(_Fragment, { children: [!isDialog ? (_jsxs(Grid, { width: "100%", gap: "8px", children: [content, !isChildrenRenderProps(children) && (_jsxs(Flex, { gap: "4px", justify: "space-between", w: "100%", children: [_jsx(Box, { flexGrow: 1 }), _jsx(IconButton, { flexShrink: 0, size: "smSquare", "aria-label": "", variant: "ghost", icon: _jsx(Svg, { size: "s12", name: "Expand" }), isDisabled: isReadOnly, onClick: handleToggleDialog })] }))] })) : (_jsx(ComponentPlacement, { onClick: handleToggleDialog })), isDialog && (_jsx(Dialog, { title: title, onClose: handleToggleDialog, isFloating: true, minWidth: dialogMinWidth, floatMinWidth: floatMinWidth, children: content }))] }));
};
//# sourceMappingURL=DialogableContainer.js.map